import { render, staticRenderFns } from "./add-shipping.vue?vue&type=template&id=6e76e098&"
import script from "./add-shipping.vue?vue&type=script&lang=js&"
export * from "./add-shipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports